const buildApiBaseUrl = (): string => {
  const host = process.env.SERVER_HOST?.trim();

  if (!host) {
    throw new Error('SERVER_HOST is not defined');
  }

  return host;
};

export const pomConfig = {
  support: 'https://tickets.miliboo.io',
  guideUrl: process.env.REACT_APP_GUIDE_URL,
  http: {
    api: buildApiBaseUrl(),
  },
  language: {
    fallback: 'en',
  },
  env: process.env.NODE_ENV,
  externalApps: {
    tms: process.env.TMS_APP,
    pim: process.env.PIM_APP,
    crm: process.env.CRM_APP,
    sav: process.env.SAV_APP,
    demandPlanning: process.env.DP_APP,
  },
};

export type PomConfig = typeof pomConfig;
